import { render, staticRenderFns } from "./SourceRatingPage.vue?vue&type=template&id=d851d96a"
import script from "./SourceRatingPage.vue?vue&type=script&lang=js"
export * from "./SourceRatingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports